import { ReactNode } from "react";

import SectionCard from "./section-card";
import { cn } from "./cn";

// 화면 하나를 차지하는 안내 카드(만료·없음·오류) — 무슨 일인지와 다음 할 일을 적는다.
interface Props {
  title: ReactNode;
  body?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const Notice = ({ title, body, actions, children, className }: Props) => (
  <SectionCard as="div" className={cn("mx-auto w-full max-w-sm p-5 text-center", className)} padding="none">
    <h1 className="text-lg font-semibold">{title}</h1>
    {body && <p className="mt-2 text-sm text-muted-foreground">{body}</p>}
    {children}
    {actions && <div className="mt-4 flex flex-wrap justify-center gap-2">{actions}</div>}
  </SectionCard>
);

export default Notice;
